import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasPlatformPreviewColorModeChanged.meta';

export type UseTrackCanvasPlatformPreviewColorModeChangedParams = {
  canvas_id: string;
  color_mode: 'light' | 'dark';
  format_id: string;
  instagram_placement?: 'feed' | 'reel';
};

export const useTrackCanvasPlatformPreviewColorModeChanged = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasPlatformPreviewColorModeChanged = useCallback(
    (params: UseTrackCanvasPlatformPreviewColorModeChangedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasPlatformPreviewColorModeChanged };
};
